import { FormControl, MenuItem, Select, Tooltip, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { useVenue } from "providers/venue"
import React, { useCallback, useMemo, useState } from "react"
import { useTranslation } from "providers/i18n"

export const LanguageSelectMenu = (props) => {
  const { t, i18n } = useTranslation()
  const { locales = [] } = useVenue()
  const [isOpen, setIsOpen] = useState(false)

  const { sx = {}, label: labelProp, ...restProps } = props

  const theme = useTheme()
  const { styleOverrides = {}, defaultProps = {} } =
    theme.components[`LanguageSelectMenu`] || {}
  const { root = {}, paper, menuList, menuItem } = styleOverrides
  const { MenuProps: defaultMenuProps } = defaultProps || {}

  const handleOpen = useCallback(
    (e) => {
      setIsOpen(!isOpen)
    },
    [setIsOpen, isOpen]
  )

  const handleChange = useCallback(
    (e) => {
      i18n.changeLanguage(e.target.value)
    },
    [i18n]
  )

  const activeLocale = useMemo(() => {
    if (!i18n.resolvedLanguage) return
    return locales.find((locale) => i18n.resolvedLanguage === locale.localeKey)
  }, [locales, i18n.resolvedLanguage])

  const { localeKey: activeLocaleKey } = activeLocale || {}

  if (locales.length <= 0) return null

  return (
    <>
      {activeLocale && (
        <Tooltip title={t("Language Settings")}>
          <FormControl>
            <Select
              value={activeLocaleKey}
              onChange={handleChange}
              onClose={handleOpen}
              onClick={handleOpen}
              open={isOpen}
              sx={deepmerge(root, sx)}
              MenuProps={{
                PaperProps: {
                  sx: paper,
                },
                MenuListProps: {
                  sx: menuList,
                },
                ...defaultMenuProps,
              }}
              {...restProps}
            >
              {locales.map((locale) => {
                return (
                  <MenuItem
                    key={locale.localeKey}
                    sx={menuItem}
                    className={
                      activeLocaleKey === locale.localeKey ? "active" : ""
                    }
                    value={locale.localeKey}
                  >
                    {t(
                      `localization.select.item.${locale.localeKey}`,
                      locale.localizedName
                    )}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        </Tooltip>
      )}
    </>
  )
}
